import PagePanelViewport from "./Viewport";
import PagePanelWrapper from "./Wrapper";

export default {
  Viewport: PagePanelViewport,
  Wrapper: PagePanelWrapper,
};
